import type {
  TimeoutCreateRequest,
  TimeoutDeleteRequest,
  TimeoutQueueEvent,
  TimeoutUpdateRequest,
} from '../types/timeout'

/**
 * The three timeout requests as the offline queue holds them and
 * `POST /games/bulkscoring` reads them. The queue adds the event's type and
 * action itself.
 *
 * A queued create keeps the id the app made for the timeout, so the same
 * timeout arriving twice is recorded once.
 */
export const toTimeoutCreateEvent = ({
  periodId,
  form,
}: TimeoutCreateRequest): TimeoutQueueEvent => ({
  id: form.uid,
  event_properties: {
    period_id: periodId,
    team_id: form.team_id,
    period_clock_time: form.period_clock_time,
    occurred_at: form.occurred_at,
  },
})

export const toTimeoutUpdateEvent = ({
  timeoutId,
  form,
}: TimeoutUpdateRequest): TimeoutQueueEvent => ({
  id: timeoutId,
  event_properties: {
    period_clock_time: form.period_clock_time,
  },
})

export const toTimeoutDeleteEvent = ({
  timeoutId,
}: TimeoutDeleteRequest): TimeoutQueueEvent => ({
  id: timeoutId,
})
